<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Listado de Platos">
          <GestionPlatosLista @open="open()" @close="close()"></GestionPlatosLista>
        </BaseCard>
      </v-col>
    </v-row>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'GestionPlato',
  components: {
    GestionPlatosLista: () => import('../components/GestionPlatosLista')
  },
  data: () => ({
    showLoading: false,
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Gestión de Platos',
        disabled: true
      },
      {
        text: 'Lista de Platos',
        disabled: true
      }
    ]
  }),
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    }
  }
};
</script>
